module.exports = __webpack_public_path__ + "static/img/11.043adad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/11.png
// module id = QQ7j
// module chunks = 0